import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';

import * as S from './styles';

interface ToastErrorProps {
	message: string;
}

export function ToastError({ message }: Readonly<ToastErrorProps>): JSX.Element {
	return (
		<S.CustomToast>
			<S.WarningIcon>
				<ExclamationCircleOutlined />
			</S.WarningIcon>
			<S.ToastMessage>{I18n.get(message)}</S.ToastMessage>
		</S.CustomToast>
	);
}
